import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=71946e0c&scoped=true"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"
import style0 from "./Config.vue?vue&type=style&index=0&id=71946e0c&prod&lang=less"
import style1 from "./Config.vue?vue&type=style&index=1&id=71946e0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71946e0c",
  null
  
)

export default component.exports